function e() {
  return o().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function o() {
  return typeof navigator != "undefined" && typeof window != "undefined" ? window : typeof globalThis != "undefined" ? globalThis : {};
}
const n = typeof Proxy == "function";
export {
  e as getDevtoolsGlobalHook,
  o as getTarget,
  n as isProxyAvailable
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@vue_devtools-api@6.6.4/~/@vue/devtools-api/lib/esm/env.js
// module id = 1318
// module chunks = 41